import React from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import Holidays from "date-holidays";
import { Row, Col } from "react-bootstrap";

import { IOperationData, ITimeSlotOperation, WeekAvailability } from "../../../constants/types";
import Icon from "../../icon/Icon";

import './TimeSlotOperation.scss'

interface Props extends WithTranslation{
    operation: ITimeSlotOperation,
    data: IOperationData,
    onChange: (changes: IOperationData) => void
};

const msDay = 1000 * 60 * 60 * 24;

class TimeSlotOperation extends React.Component<Props> {

    constructor(props: Props) {
        super(props);
    }

    verifySlots(days: any) {
        const { minNumberOfSlots, availabletime } = this.props.operation;
        //@ts-ignore: F**K ts
        const availableSlots = Object.keys(availabletime).filter((key) => availabletime[key] === true);
        const numOfSlots = Object.keys(days)
                            .filter(k => days[k] !== undefined)
                            .reduce((acc, k) => {
                                const day = days[k]
                                
                                return acc + (day.wholeDay ? availableSlots.length : availableSlots.filter(slot => day[slot] === true).length);
                            }, 0);

        return numOfSlots >= minNumberOfSlots;
    }

    toggleDay(day: string) {
        const { data } = this.props;
        const disable = data?.days?.[day]?.wholeDay === true;
        const newDays = {
            ...data.days,
            [day]: disable ? undefined : {
                wholeDay: !data?.days?.[day]?.wholeDay
            }
        }

        this.props.onChange({
            OK: this.verifySlots(newDays),
            discarded: false,
            days: newDays
        });
    }

    toggleTimeSlot(day: string, slot: string) {
        const { data, operation } = this.props;
        const { availabletime } = operation;
        const dataDay = data?.days?.[day];
        let newDay = {
            ...dataDay,
            wholeDay: false,
            [slot]: !(dataDay?.[slot])
        }
        //@ts-ignore: F**K ts
        const availableSlots = Object.keys(availabletime).filter((key) => availabletime[key] === true);;
        const numOfSlots = availableSlots.filter(k => newDay[k] === true).length;

        if(numOfSlots === availableSlots.length) {
            newDay = {
                wholeDay: true
            }
        }
        else if(numOfSlots === 0) {
            newDay = undefined;
        }

        const newDays = { ...data.days, [day]: newDay };

        this.props.onChange({
            OK: this.verifySlots(newDays),
            discarded: false,
            days: newDays
        });
    }

    getDays(numberOfDays: number, availabledays: WeekAvailability, allowHolidays: boolean) {
        let days: number[] = [];
        let day = new Date(Date.now());
        let holidays = new Holidays("SE");

        let loops = 0;
        while(days.length < numberOfDays && loops < 100) {
            if(
                (availabledays !== "WORK-WEEK" || (day.getDay() < 5))
                && (allowHolidays || !holidays.isHoliday(day))
            ) {
                days.push(day.getTime());
            }

            day.setDate(day.getDate() + 1);
            loops++;
        }

        return days.map(d => new Date(d + msDay));
    }

    renderTimeSlots(operation: ITimeSlotOperation) {
        const { t, data } = this.props;
        const { numberOfDays, availabledays, allowHolidays, availabletime } = operation;
        let days = this.getDays(numberOfDays, availabledays, allowHolidays);

        return <Row className="time-slot-list">
            {days.map(day => {
                const dataDay = data?.days?.[day.toDateString()];

                return <Col xs={6} md={3} className="fade-in">
                    <div className="time-slot" aria-selected={dataDay !== undefined} >
                        <div className="time-slot-date" aria-selected={dataDay?.wholeDay === true} onClick={() => this.toggleDay(day.toDateString())}>
                            <div className="time-slot-date-checkmarker">
                                <Icon type={"CHECKMARK"} />
                            </div>
                            <div className="time-slot-date-string">
                                {t(`general.time.days-short.${day.getDay()}` as unknown as TemplateStringsArray)} {`(${day.getDate()}/${day.getMonth()})`}
                            </div>
                        </div>
                        <div className="time-slot-availabletime">
                            {Object.keys(availabletime).map((key: string) => {
                                //@ts-ignore: F**k ts sometimes
                                if(availabletime[key] == true) {
                                    return <div className="time-slot-available-slot" aria-selected={dataDay?.[key] === true || dataDay?.wholeDay === true} onClick={() => this.toggleTimeSlot(day.toDateString(), key)}>
                                        {t(`general.time.${key}-short` as unknown as TemplateStringsArray)}
                                    </div>;
                                }
                                return null;
                            })}
                        </div>
                    </div>
                </Col>;
            })}
        </Row>;
    }

    render() {
        const { operation } = this.props;
        return <div className="render-time-slot-operation" >
            {this.renderTimeSlots(operation)}
        </div>;
    }
};

export default withTranslation()(TimeSlotOperation);